import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmInput } from '@spartan-ng/helm/input';
import { HlmLabel } from '@spartan-ng/helm/label';

export interface AskConfirmationDialogContext {
  resource: string;
  close: (result?: boolean) => void;
}

@Component({
  selector: 'app-ask-confirmation-dialog',
  template: `
    <section class="p-6">
      <h3 class="text-lg font-semibold mb-2">Delete this permanently?</h3>
      <div class="my-2">
        <strong>You cannot undo this.</strong>
      </div>
      
      <div class="mt-4">
        <label hlmLabel for="resource-name">To confirm, type the name of what you delete</label>
        <input 
          hlmInput
          id="resource-name"
          name="name" 
          [formControl]="resourceToDelete" 
          required 
          class="w-full"
        />
      </div>

      <div class="flex justify-center gap-3 mt-6">
        <button hlmBtn variant="outline" (click)="cancel()">Cancel</button>
        <button
          hlmBtn
          variant="destructive"
          [disabled]="!resourceToDelete.valid"
          (click)="confirm()">
          Confirm
        </button>
      </div>
    </section>
  `,
  imports: [
    HlmLabel,
    HlmInput,
    FormsModule,
    ReactiveFormsModule,
    HlmButtonImports,
  ],
})
export class AskConfirmationDialogComponent implements OnInit {
  private context = injectBrnDialogContext<AskConfirmationDialogContext>();
  
  get data() {
    return { resource: this.context.resource };
  }

  resourceToDelete!: UntypedFormControl;

  ngOnInit(): void {
    this.resourceToDelete = new UntypedFormControl('', Validators.pattern(this.data.resource));
  }

  cancel(): void {
    this.context.close(false);
  }

  confirm(): void {
    if (this.resourceToDelete.valid) {
      this.context.close(true);
    }
  }
}
